module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_3_m.c6e1b1296a03d5d1709823947985d12b.png";